
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project-details",
      function () {
        return require("private-next-pages/project-details.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project-details"])
      });
    }
  